import { enableProdMode } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';
import { AppConfigService } from './app/configuration/services/app-config.service';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { APP_CONFIG } from './app/configuration/configuration.module';
import { initSentry } from './app/configuration/sentry.module';

AppConfigService.loadAppConfig()
  .then((config) => {
    initSentry(config);

    if (environment.production) {
      enableProdMode();
    }

    platformBrowser([
      {
        provide: APP_CONFIG,
        useValue: config,
      },
    ])
      .bootstrapModule(AppModule)
      .catch((err) => {
        Sentry.captureException(err);
        console.error(err);
      });
  })
  .catch((e) => console.error(e));
